import React, { useEffect, useState  } from "react";

import {useManageGetRequest} from "../../../../../hooks/useManageGetRequest/useManageGetRequest";

import {
    cuadroRequerimientosGetRatiosActualAPI,
} from '../../../../../consumers/backendApisUrls';

import styled from "styled-components";

const Container = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 16px;
  max-width: 700px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

const Thead = styled.thead`
  background-color: #f5f6f8;
`;

const Th = styled.th`
  padding: 10px;
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 1px solid #d1d5db;
`;

const Tr = styled.tr`
  border-bottom: 1px solid #e5e7eb;
`;

const Td = styled.td`
  padding: 8px 10px;
  color: #333;
`;

const ValueTd = styled(Td)`
  width: 120px;
  font-weight: 600;
  text-align: center;
`;

const FooterNote = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #6b7280;
`;

const data = {
    ExtraData: {
        PuedeRecalcular: true
    },
    TotalPages: 1,
    TotalItems: 3,
    CurrentPage: 1,
    ItemsPerPage: 20,
    Items: [
        {
            Id: 1,
            Indicador: "N° Profesores",
            Valor: 0,
            Observacion: "N° total de Profesores sin contar los de inicial"
        },
        {
            Id: 2,
            Indicador: "N° Salones",
            Valor: 22,
            Observacion: "N° total de salones sin contar los de inicial"
        },
        {
            Id: 3,
            Indicador: "Ratio Eficiencia",
            Valor: 0,
            Observacion: "N° de Profesores / N° de salones"
        }
    ]
};

const FlagIcon = ({ Color }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 24 24"
    fill={Color === "green" ? "#16a34a":"#dc2626" }  // rojo o verde
    style={{ marginLeft: "6px", verticalAlign: "middle", cursor: "pointer" }}

  >
    <path d="M4 21V4.707C4 4.316 4.316 4 4.707 4H6.586L8 5.414L9.414 4H14.586C14.977 4 15.293 4.316 15.293 4.707V12.707C15.293 13.098 14.977 13.414 14.586 13.414H11L9.586 14.828L8 13.414H4.707C4.316 13.414 4 13.098 4 12.707V21Z" />
  </svg>
);

export default function CuadroRequerimientosKpisActualesTab({ idCuadroSede }) {

    const [executeManageGet] = useManageGetRequest();    
    const [modalData, setModalData] = useState({});
    const getData = async () => { 
        const api = cuadroRequerimientosGetRatiosActualAPI(idCuadroSede);
        await executeManageGet(api, ({ data }) => getDataCallBack(data), false);
    }

    const getDataCallBack = async (data) => {         
        setModalData(data);
    };

    const getInitData = async () => {
        getData();        
    }

    const init = async () => { 
        getInitData();
    };

    useEffect(() => { 
        init(); 
    }, []);
    
    return (
        <Container>
            <Table>
            <Thead>
                <Tr>
                <Th>Indicadores</Th>
                <Th></Th>
                <Th>Observaciones</Th>
                </Tr>
            </Thead>

            <tbody>
                <Tr>
                <Td>N° Profesores</Td>
                <ValueTd>{modalData?.NroProfesores ?? 0}</ValueTd>
                <Td>N° total de Profesores sin contar los de inicial</Td>
                </Tr>

                <Tr>
                <Td>N° Salones</Td>
                <ValueTd>{modalData?.NroSecciones ?? 0}</ValueTd>
                <Td>N° total de salones sin contar los de inicial</Td>
                </Tr>
        
                <Tr>
                <Td>Ratio Eficiencia</Td>
                <ValueTd>
                    {modalData?.RatioCalculado ?? 0}
                    {
                        <FlagIcon Color={modalData.Color} />
                    }
                </ValueTd>
                <Td>N° de Profesores / N° de salones</Td>
                </Tr>
                <Tr>
                    <Td>
                        Promedio de bloques {modalData?.AnioCampana ?? ""}
                    </Td>
                    <ValueTd>
                        {modalData?.PromedioBloquesPorProfesor || "-"}
                    </ValueTd>
                    <Td>
                        Promedio de bloques por profesor
                    </Td>
                </Tr>
            </tbody>
            </Table>

            <FooterNote>
            * Los valores se calculan automáticamente según la asignación actual
            </FooterNote>
        </Container>
    );
} 